var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.examInfo
    ? _c("div", { staticClass: "check-exam-status" }, [
        _c(
          "div",
          { staticClass: "exam-header" },
          [
            _c(
              "el-row",
              { attrs: { type: "flex", justify: "space-between" } },
              [
                _c(
                  "el-col",
                  { staticClass: "exam-title", attrs: { span: 8 } },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "light",
                          content: _vm.examInfo.manageName,
                          placement: "bottom",
                        },
                      },
                      [_c("h3", [_vm._v(_vm._s(_vm.examInfo.manageName))])]
                    ),
                  ],
                  1
                ),
                _c("el-col", { attrs: { span: 8 } }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.dsf.cookies.get("isDd"),
                          expression: "!dsf.cookies.get('isDd')",
                        },
                      ],
                      staticClass: "goback",
                    },
                    [
                      _c("div", [
                        _c("i", {
                          staticClass: "iconfont icon-guanbi2",
                          attrs: { title: "关闭" },
                          on: { click: _vm.closePage },
                        }),
                        _c(
                          "span",
                          {
                            staticClass: "closeitem",
                            on: { click: _vm.closePage },
                          },
                          [_vm._v("关闭")]
                        ),
                      ]),
                    ]
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "exam-main" }, [
          _c("div", { staticClass: "status-wrapper" }, [
            _c(
              "div",
              {
                class: {
                  "status-info": true,
                  success: _vm.examInfo.isPass === "1",
                  failed: _vm.examInfo.isPass === "0",
                  other:
                    _vm.examInfo.isPass !== "1" || _vm.examInfo.isPass === "0",
                },
              },
              [
                _c("div", { staticClass: "exam-user" }, [
                  _c(
                    "div",
                    { staticClass: "exam-user-photo" },
                    [
                      _vm.examInfo.userId
                        ? _c("el-avatar", {
                            attrs: {
                              size: 100,
                              src:
                                "/oua2/getUserPhoto?type=relativePath&userId=" +
                                _vm.examInfo.userId,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "exam-user-name" }, [
                    _c("span", [_vm._v(_vm._s(_vm.examInfo.userName))]),
                  ]),
                ]),
                _c(
                  "el-tooltip",
                  {
                    staticClass: "item",
                    attrs: {
                      effect: "light",
                      content: _vm.examInfo.manageName,
                      placement: "top",
                    },
                  },
                  [
                    _c("div", { staticClass: "exam-title" }, [
                      _c("p", [_vm._v(_vm._s(_vm.examInfo.manageName))]),
                    ]),
                  ]
                ),
                _c("div", { staticClass: "exam-dividing-line" }),
                _vm.examInfo.status === "完成"
                  ? _c("div", { staticClass: "content" }, [
                      _c("div", { staticClass: "exam-scors-wrapperpass" }, [
                        _c("div", [
                          _c(
                            "span",
                            {
                              class: {
                                "exam-scors": true,
                                "exam-scors-pass": _vm.examInfo.isPass === "1",
                                "exam-scors-fail": _vm.examInfo.isPass === "0",
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.examInfo.showText) + " ")]
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "exam-stars" }, [
                        _c("div", { staticClass: "icon_star_r icon_star" }, [
                          _vm.examInfo.isPass === "1"
                            ? _c("img", {
                                staticClass: "icon",
                                attrs: { src: "/static/img/icon_star_r.png" },
                              })
                            : _vm.examInfo.isPass === "0"
                            ? _c("i", {
                                staticClass: "icon iconfont icon-icon_star_r2",
                              })
                            : _vm._e(),
                        ]),
                        _c("div", { staticClass: "icon_star_c icon_star" }, [
                          _vm.examInfo.isPass === "1"
                            ? _c("img", {
                                staticClass: "icon",
                                attrs: { src: "/static/img/icon_star_c.png" },
                              })
                            : _vm.examInfo.isPass === "0"
                            ? _c("i", {
                                staticClass: "icon iconfont icon-icon_star_c2",
                              })
                            : _vm._e(),
                        ]),
                        _c("div", { staticClass: "icon_star_l icon_star" }, [
                          _vm.examInfo.isPass === "1"
                            ? _c("img", {
                                staticClass: "icon",
                                attrs: { src: "/static/img/icon_star_l.png" },
                              })
                            : _vm.examInfo.isPass === "0"
                            ? _c("i", {
                                staticClass: "icon iconfont icon-icon_star_l2",
                              })
                            : _vm._e(),
                        ]),
                      ]),
                      _vm.examInfo.isPass !== "不公布"
                        ? _c("div", { staticClass: "exam-status-pic" }, [
                            _vm.examInfo.isPass === "1"
                              ? _c("img", {
                                  staticClass: "icon",
                                  attrs: { src: "/static/img/icon_ytg.png" },
                                })
                              : _vm.examInfo.isPass === "0"
                              ? _c("img", {
                                  staticClass: "icon",
                                  attrs: { src: "/static/img/icon_wtg.png" },
                                })
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ])
                  : _c("div", { staticClass: "content" }, [
                      _vm.examInfo.status
                        ? _c("div", [
                            _c("div", { staticClass: "exam-piyue-name" }, [
                              _vm._v(_vm._s(_vm.examInfo.status)),
                            ]),
                            _c("div", { staticClass: "exam-piyue-tips" }, [
                              _vm._v("交卷成功，请等待成绩公布！"),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
              ],
              1
            ),
            _vm.examInfo.status
              ? _c(
                  "div",
                  { staticClass: "exam-button-bar" },
                  [
                    _vm.examInfo.status
                      ? _c(
                          "router-link",
                          {
                            staticClass: "exam-button-item",
                            attrs: {
                              to:
                                "/pc/exam/exam-record?id=" +
                                _vm.$route.query.recordId +
                                "&type=record",
                            },
                          },
                          [_vm._v(" 查看详情 ")]
                        )
                      : _vm._e(),
                    _vm.examInfo.status !== "历史" &&
                    _vm.examInfo.remainNum !== "0"
                      ? _c(
                          "div",
                          {
                            staticClass: "exam-button-item",
                            on: { click: _vm.tryAgain },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "再考一次" +
                                  _vm._s(
                                    _vm.examInfo.infinite === true
                                      ? "(不限次)"
                                      : "(" + _vm.examInfo.remainNum + "次)"
                                  )
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }